'use client';

import { c as _c } from "react/compiler-runtime";
import { FulfillmentOptions, FulfillmentTile, InventoryStatus, SddDetails } from '../product-details';
import { MiniPdpBopisDetails } from './mini-pdp-bopis-details';
import type { MiniPdpFulfillmentProps } from './model/use-mini-pdp-fulfillment';
import { useMiniPdpFulfillment } from './model/use-mini-pdp-fulfillment';
export function MiniPdpFulfillment(t0) {
  const $ = _c(28);
  const {
    product,
    tailored,
    isLoading,
    isError: t1,
    onOpenSddAddress,
    onOpenStoreDrawer
  } = t0;
  const isError = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isError || $[1] !== isLoading || $[2] !== onOpenSddAddress || $[3] !== product || $[4] !== tailored) {
    t2 = {
      product,
      tailored,
      isLoading,
      isError,
      onOpenSddAddress
    };
    $[0] = isError;
    $[1] = isLoading;
    $[2] = onOpenSddAddress;
    $[3] = product;
    $[4] = tailored;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    fulfillmentMethods,
    register,
    sddDetails,
    inventoryStatus
  } = useMiniPdpFulfillment(t2);
  let t3;
  if ($[6] !== fulfillmentMethods || $[7] !== register) {
    let t4;
    if ($[9] !== register) {
      t4 = method => <FulfillmentTile key={method.value} {...method} inputProps={register} />;
      $[9] = register;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = fulfillmentMethods.map(t4);
    $[6] = fulfillmentMethods;
    $[7] = register;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <FulfillmentOptions data-testid="mini-pdp-fulfillment-options">{t3}</FulfillmentOptions>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== sddDetails) {
    t5 = sddDetails && <SddDetails {...sddDetails} className="delivery-details__container" />;
    $[13] = sddDetails;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isError || $[16] !== isLoading || $[17] !== onOpenStoreDrawer || $[18] !== product || $[19] !== tailored) {
    t6 = <MiniPdpBopisDetails product={product} tailored={tailored} isLoading={isLoading} isError={isError} onOpenStoreDrawer={onOpenStoreDrawer} />;
    $[15] = isError;
    $[16] = isLoading;
    $[17] = onOpenStoreDrawer;
    $[18] = product;
    $[19] = tailored;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== inventoryStatus) {
    t7 = inventoryStatus && <InventoryStatus isLoading={inventoryStatus.isLoading} label={inventoryStatus.label} tone={inventoryStatus.tone} />;
    $[21] = inventoryStatus;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className="mini-pdp-drawer__fulfillment">{t4}{t5}{t6}{t7}</div>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}